module.exports = __webpack_public_path__ + "img/TALHADEIRA CÔNICA PONTA PLANA   - MOBILE.9f63e81f.png";